// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import RemarkGfm from "remark-gfm";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import ReactMarkdown from "react-markdown";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import * as Blog$BenfaerberBlog from "../lib/Blog.bs.js";
import * as Flag$BenfaerberBlog from "../components/Flag.bs.js";
import * as Tags$BenfaerberBlog from "../components/Tags.bs.js";
import * as AppContext$BenfaerberBlog from "../AppContext.bs.js";
import * as CodeRenderer$BenfaerberBlog from "../lib/CodeRenderer.bs.js";
import * as ArticleLoading$BenfaerberBlog from "../components/ArticleLoading.bs.js";

function s(prim) {
  return prim;
}

function ArticlePage(props) {
  var match = ReactRouterDom.useParams();
  var slug = match.slug;
  var match$1 = React.useContext(AppContext$BenfaerberBlog.context);
  var language = match$1.language;
  var match$2 = React.useState(function () {
        return {
                content: undefined,
                article: undefined,
                loadedLanguage: undefined
              };
      });
  var setState = match$2[1];
  var state = match$2[0];
  var unwrappedSlug = Belt_Option.getWithDefault(slug, "");
  React.useEffect((function () {
          setState(function (param) {
                return {
                        content: undefined,
                        article: undefined,
                        loadedLanguage: undefined
                      };
              });
          Blog$BenfaerberBlog.Api.getArticles().then(function (articles) {
                var article = Belt_Array.getBy(articles, (function (a) {
                        return a.slug === unwrappedSlug;
                      }));
                if (article === undefined) {
                  return Promise.resolve(setState(function (param) {
                                  return {
                                          content: undefined,
                                          article: undefined,
                                          loadedLanguage: undefined
                                        };
                                }));
                }
                var resolvedLang = Blog$BenfaerberBlog.resolveLanguage(article, language);
                return Blog$BenfaerberBlog.Api.getArticle(unwrappedSlug, resolvedLang).then(function (content) {
                            return Promise.resolve(setState(function (param) {
                                            return {
                                                    content: content,
                                                    article: article,
                                                    loadedLanguage: resolvedLang
                                                  };
                                          }));
                          });
              });
        }), [
        slug,
        language
      ]);
  var transformImageUri = function (src, _alt, _title) {
    if (src !== undefined) {
      return Js_string.replace("../", "/", src);
    } else {
      return "";
    }
  };
  var content = state.content;
  var tmp;
  if (content !== undefined) {
    var article = state.article;
    tmp = article !== undefined ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("h1", {
                                          children: article.title
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: Belt_Array.mapWithIndex(article.languages, (function (i, lang) {
                                                  return JsxRuntime.jsx(Flag$BenfaerberBlog.make, {
                                                              language: lang,
                                                              className: "article-flag"
                                                            }, String(i));
                                                })),
                                          className: "article-flags is-flex is-align-items-center ml-2"
                                        })
                                  ],
                                  className: "is-flex is-align-items-center"
                                }),
                            className: "article-header-title"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Tags$BenfaerberBlog.make, {
                                    tags: article.tags
                                  }),
                              JsxRuntime.jsx("div", {
                                    className: "mb-1"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: Blog$BenfaerberBlog.datestampToPrettyDate(article.date),
                                    className: "monospace w100 has-text-right"
                                  })
                            ],
                            className: "article-header-meta"
                          })
                    ],
                    className: "article-header is-flex is-justify-content-space-between"
                  }),
              JsxRuntime.jsx(ReactMarkdown, {
                    children: content,
                    components: CodeRenderer$BenfaerberBlog.renderer,
                    transformImageUri: transformImageUri,
                    remarkPlugins: [RemarkGfm]
                  })
            ]
          }) : JsxRuntime.jsx("span", {
            children: "Article not found!"
          });
  } else {
    tmp = JsxRuntime.jsx(ArticleLoading$BenfaerberBlog.make, {});
  }
  return JsxRuntime.jsx("article", {
              children: tmp,
              className: "article"
            });
}

var make = ArticlePage;

export {
  s ,
  make ,
}
/* react Not a pure module */
